import { css } from '@nx-kit/styling';

export const teaserDecoration = css`
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.12);
  transition: box-shadow 300ms ${({ theme }) => theme.global.easing.snappy};
  &:hover {
    box-shadow: 0 5px 18px rgba(0, 0, 0, 0.2);
  }
`;
